import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'addDistrict',
})
export class AddDistrictPipe implements PipeTransform {
  transform(value: string, district: string, applicationType: string): string {
    if (district && (applicationType === 'registration_of_energy_producer' || applicationType === 'gridcomp_feedin')) {
      value = value + `/${district}`;
    }

    return value;
  }
}
